<template>
  <div class="loading-spinner">
    <Spinner/>
  </div>
</template>

<script setup lang="ts">
import Spinner from '@/assets/Spinner.svg'
</script>

<style lang="scss">
.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: $white;

  .Spinner_svg {
    &__spinner {
    animation: rotate 2s linear infinite;
    mix-blend-mode: lighten;
    height: 85px;
    }

    &__path {
      stroke: $white;
      stroke-linecap: square;
      animation: dash 1.5s ease-in-out infinite;
    }
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }

}
</style>